/**
 * Created by mglynn on 11/7/2016.
 */
/**
 * Provides an interface for dropping a document on an area and executing an associated action
 * @module app/views/Documents/DragDropView
 */
import Backbone from "backbone";
import _ from "underscore";
import $ from "jquery";
import velocity from "velocity-animate";
import viewTemplate from "views/documents/DragDropView";
function effectAllowed(evt, effect) {
  if (isIE()) {
    return true;
  }

  return (
    evt &&
    evt.originalEvent &&
    evt.originalEvent.dataTransfer &&
    evt.originalEvent.dataTransfer.effectAllowed == effect
  );
}

function isIE() {
  return (
    navigator.userAgent.indexOf("MSIE") !== -1 ||
    navigator.userAgent.indexOf("Trident") !== -1
  );
}

function hasFiles(evt) {
  return (
    evt &&
    evt.originalEvent &&
    evt.originalEvent.dataTransfer &&
    evt.originalEvent.dataTransfer.files &&
    evt.originalEvent.dataTransfer.files.length
  );
}

var DragDropView = Backbone.View.extend(
  {
    events: {
      drop: function (evt) {
        if (effectAllowed(evt, "all")) {
          this.counter = 0;
          this.setAppearance(DragDropView.DROP, true);
          if (hasFiles(evt)) {
            this.trigger("drop", evt);
          } else {
            this.trigger("droperror", evt);
          }
        }
      },
      dragover: function (evt) {
        evt.preventDefault();
        evt.stopPropagation();
      },
      dragenter: function (evt) {
        evt.preventDefault(); // needed for IE
        if (effectAllowed(evt, "all")) {
          this.counter++;
          this.setAppearance(DragDropView.DONE, true);
        }
        evt.stopPropagation();
      },
      dragexit: function (evt) {
        if (effectAllowed(evt, "all")) {
          this.setAppearance(DragDropView.DROP, true);
          this.counter = 0;
        }
      },
      dragend: function (evt) {
        if (effectAllowed(evt, "all")) {
          this.setAppearance(DragDropView.DROP, true);
          this.counter = 0;
        }
      },
      dragleave: function (evt) {
        if (effectAllowed(evt, "all")) {
          this.counter--;
          if (this.counter === 0) {
            this.setAppearance(DragDropView.DROP, true);
          }
        }
      },
    },

    template: viewTemplate,

    /**
     * Initializes the view.
     * @param  {object} options The options hash.
     * @param {string} options.appearance The action to take when the file is dropped which takes in the drop event as a parameter
     * @param {boolean} options.allowDropFiles
     */
    initialize: function (options) {
      this.options = _.defaults({}, options, {
        appearance: DragDropView.DROP,
      });
      this.counter = 0;
      this.render();
      this.setAppearance(options.appearance, true);
    },

    /**
     * Sets the base map.
     * @param {string} appearance The identifier of style to set.
     * @param {Boolean} [immediate] True to perform the transition immediately.
     */
    setAppearance: function (appearance, immediate) {
      var showContainers = [];
      var hideContainers = [];

      this._appearance = appearance;

      this.$containers.each(function () {
        var $el = $(this);

        if ($el.hasClass(appearance)) {
          showContainers.push(this);
        } else {
          hideContainers.push(this);
        }
      });

      if (immediate) {
        $(hideContainers).css("opacity", 0);
        $(showContainers).css("opacity", 1);
      } else {
        velocity(
          hideContainers,
          {
            opacity: 0,
          },
          {
            duration: 400,
            queue: false,
          }
        );
        velocity(
          showContainers,
          {
            opacity: 1,
          },
          {
            duration: 400,
            queue: false,
          }
        );
      }
    },
    /**
     * Renders the view to show the state of the deferred object or originally renders a default view
     */
    render: function () {
      // Load the compiled HTML into the Backbone "el"
      this.$el.html(this.template());
      this.$containers = this.$(".drag-drop-container > div");
      this.delegateEvents();
    },
  },
  {
    PROGRESS: "drag-drop-table-progress",
    DONE: "drag-drop-table-green",
    DROP: "drag-drop-table-blue",
  }
);

export default DragDropView;



//////////////////
// WEBPACK FOOTER
// ./public/js/app/views/documents/DragDropView.js
// module id = 897
// module chunks = 1